export const videoIds: Record<string, string> = {
  pt: "ZOMsm0NPDNc",
  es: "c8UH5c2C2SE",
  en: "jklvLC0Jves",
};
